import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';
import ButtonCollapse from 'components/Widgets/ButtonCollapse';

export default function Languages({ coach }) {
  const id = `coach-${coach.id}-languages`;
  const alwaysShow = 2;

  if (coach.attributes.languages === 0) {
    return null;
  }

  return (
    <div className="p-3 border rounded-4">
      <h6 className="mb-3">
        Languages
      </h6>

      <div className="fw-light">
        {coach.attributes.languages.slice(0, alwaysShow).map((lang) => (
          <IconWithText
            key={lang.id}
            iconClassName="small-icon picture-icon"
            iconStyle={{
              backgroundImage: `url(${lang.flag})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
            wrapperClassName="mb-3"
            contentClassName="small"
          >
            {lang.title}
          </IconWithText>
        ))}

        {coach.attributes.languages.length > alwaysShow && (
          <div className={`${id} collapse`}>
            {coach.attributes.languages.slice(alwaysShow).map((lang) => (
              <IconWithText
                key={lang.id}
                iconClassName="small-icon picture-icon"
                iconStyle={{
                  backgroundImage: `url(${lang.flag})`,
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
                wrapperClassName="mb-3"
                contentClassName="small"
              >
                {lang.title}
              </IconWithText>
            ))}
          </div>
        )}
      </div>

      {coach.attributes.languages.length > alwaysShow && (
        <ButtonCollapse
          target={`.${id}`}
          controls={id}
          className="btn-sm text-gray-900 text-decoration-none fw-semibold"
        />
      )}
    </div>
  );
}

Languages.propTypes = {
  coach: PropTypes.object.isRequired,
};
